import type { SyncWorkerCleanupOptions } from './syncWorkerCleanup';

/** @deprecated Sem efeito desde a 4.0.0 — ver `syncWorkerCleanup.ts`. */
export function registerSyncWorkerCleanup(_options: SyncWorkerCleanupOptions = {}): NodeJS.Signals[] {
  return [];
}
